module.exports = __webpack_public_path__ + "static/media/24UHCHR23.dff1c04f.jpg";